import { render, staticRenderFns } from "./BlogHolidayShoppers.vue?vue&type=template&id=4f5524c1"
import script from "./BlogHolidayShoppers.vue?vue&type=script&lang=js"
export * from "./BlogHolidayShoppers.vue?vue&type=script&lang=js"
import style0 from "./BlogHolidayShoppers.vue?vue&type=style&index=0&id=4f5524c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports